import React, { useRef } from 'react'
import { Toolbar } from '~/app/components'
import yaLogo from '~/app/imgs/empty-thumnail-yanolja-h-56.svg?inline'
import useToolbarScroll from '~/app/components/common/Toolbar/useToolbarScroll'
import { Icon_my } from '@yanolja-org/ya-com-system-icon'
import { Layout, ContentContainer, Content } from '~/app/components/layout-style'
import { Notice, Title, User } from '~/app/components/order-list/common/OrderDetailsCommonStyled'
import {
  Capacity,
  Options,
  QRCode,
  RatePlanTitle,
  RoundedRect,
  SelfCheckInNumber,
  SelfCheckInPanel,
  Subtitle,
  Time,
} from '~/app/components/order-list/details/SelfCheckIn/SelfCheckInStyled'

/**
 * SelfCheckIn component
 * author: soojin.oh
 */

// type definitions
type SelfCheckInProps = {
  title: string
  subTitle: string
  ratePlanTitle?: string
  options?: string
  capacity?: string
  startAt: [string, string]
  endAt: [string, string]
  userName: string
  phone?: string
  selfCheckInNumber: string
  loading: boolean
  qrCode: string
  onClickBack: () => void
}

// index component
const SelfCheckIn: React.FunctionComponent<SelfCheckInProps> = function ({
  title,
  subTitle,
  ratePlanTitle,
  options,
  capacity,
  startAt,
  endAt,
  userName,
  phone,
  selfCheckInNumber,
  qrCode,
  onClickBack,
}) {
  const scrollTarget = useRef<HTMLDivElement>(null)
  const { hasShadow } = useToolbarScroll(scrollTarget)
  return (
    <Layout>
      <Toolbar
        title={'셀프체크인 QR코드'}
        type={'close'}
        onClickBackButton={onClickBack}
        hasShadow={hasShadow}
      />
      <ContentContainer>
        <Content ref={scrollTarget} style={{ padding: 0, justifyContent: 'flex-start' }}>
          <SelfCheckInPanel>
            <Title>{title}</Title>
            <Subtitle>{subTitle}</Subtitle>
            {ratePlanTitle && <RatePlanTitle>{ratePlanTitle}</RatePlanTitle>}
            {options && <Options>{options}</Options>}
            {capacity && (
              <Capacity>
                <Icon_my size={1.4} unit="rem" />
                {capacity}
              </Capacity>
            )}
            <RoundedRect>
              <div className={'text'}>QR 코드를 스캔해 주세요</div>
            </RoundedRect>
            <QRCode>
              <img src={qrCode ? qrCode : yaLogo} alt={'QR 코드'} />
            </QRCode>
            <SelfCheckInNumber>{selfCheckInNumber}</SelfCheckInNumber>
            <Time>
              <div>
                <div className={'title'}>체크인</div>
                <div className={'date'}>{startAt[0]}</div>
                <div className={'time'}>{startAt[1]}</div>
              </div>
              <div>
                <div className={'title'}>체크아웃</div>
                <div className={'date'}>{endAt[0]}</div>
                <div className={'time'}>{endAt[1]}</div>
              </div>
            </Time>
            <User>
              <div className={'title'}>이용자 정보</div>
              <div>
                <div className={'sub-title'}>이름</div>
                <div className={'description'}>{userName}</div>
              </div>
              <div>
                <div className={'sub-title'}>휴대폰번호</div>
                <div className={'description'}>{phone || ''}</div>
              </div>
            </User>
          </SelfCheckInPanel>
          <Notice>
            <div className={'title'}>이용안내</div>
            <ul>
              <li>
                QR체크인 기기에 QR코드를 찍거나 QR코드 아래의 숙소 예약번호를 입력하면 자동
                체크인되며 기기에서 객실카드를 받을 수 있습니다.
              </li>
              <li>체크아웃 후에는 QR코드를 확인할 수 없습니다.</li>
              <li>
                체크인 전 고객센터 문의 시, 빠른 응대를 위해 QR코드 아래의 숙소 예약번호를
                상담원에게 알려주세요.
              </li>
            </ul>
          </Notice>
        </Content>
      </ContentContainer>
    </Layout>
  )
}

export default SelfCheckIn
